import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";

export default function PeopleCounterRedirect() {
  const { permissions } = useAuth();

  if (permissions?.view_people_counter_devices) {
    return <Navigate to="/people-counter/devices" replace />;
  }

  if (permissions?.view_people_counter_statistics) {
    return <Navigate to="/people-counter/statistics" replace />;
  }

  return <Navigate to="/people-counter/devices" replace />;
}
